<template>
  <v-content>
    <v-container fill-height>
      <v-layout justify-center align-center>
        <v-flex>
          <h1 class="titulos">Modificar Horarios de {{ this.$route.params.name }}</h1>
          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            :pagination.sync="pagination"
            class="table-margin"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-select
                  label="Seleccionar"
                  :items="week_days"
                  item-text="name"
                  item-value="week_day"
                  multiple
                  chips
                  max-height="400"
                  hint="Días de la semana"
                  persistent-hint
                  :value="props.item.ResourceHourDays"
                  @change="(event) => { dayChange(event, props.item) }"
                ></v-select>
              </td>
              <td>{{ props.item.start_time }}</td>
              <td>{{ props.item.end_time }}</td>
            </template>
          </v-data-table>
          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
          <v-snackbar
            :timeout= 6000
            :color="color"
            :multi-line="'multi-line'"
            v-model="snackbar">
            <v-icon dark>error_outline</v-icon>
            {{ error }}
            <v-btn dark flat @click.native="snackbar = false">Cerrar</v-btn>
          </v-snackbar>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
/* eslint-disable */
  import Shared from '@/services/Shared';
  import moment from 'moment'
  export default {
    data() {
      return {
        items: [],
        headers: [
          { text: 'Días', value: 'days', sortable: false},
          { text: 'Hora de inicio', value: 'start_time', sortable: false},
          { text: 'Hora de fin', value: 'end_time', sortable: false}
        ],
        dialog: false,
        options: {},
        pagination: {
          rowsPerPage: 10
        },
        error: null,
        snackbar: false,
        color: '',
        days: '',
        week_days: [
          { name: 'Lunes', abbr: 'L', week_day: 1 },
          { name: 'Martes', abbr: 'M', week_day: 2 },
          { name: 'Miércoles', abbr: 'X', week_day: 3 },
          { name: 'Jueves', abbr: 'J', week_day: 4 },
          { name: 'Viernes', abbr: 'V', week_day: 5 }
        ],
      }
    },
    created() {
      this.resourcesSchedule()
    },
    methods: {
      async resourcesSchedule() {
        try {
          const response = await Shared.resourcesSchedule(this.$route.params.id)
          this.items = response.data.data
        } catch (err) {
          console.log(err)
        }
      },
      navigateTo (route) {
        this.$router.push(route)
      },
      async dayChange (value, item) {
        var items = {
          hour_id: item.id,
          dias: value,
          resource_id: this.$route.params.id
        }
         try{
            const response = await  Shared.updateDays(items)
           this.error = response.data.msg
           this.snackbar = true
           this.color = 'success'
           //this.resourcesSchedule()
         }catch(err){
           this.error = err.response.msg
           this.snackbar = true
           this.color = 'error'
         }
      }
    },
    computed: {
      pages () {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0

        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      }
    }
  };
</script>


<style scoped>
  .table-margin{
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/EditResourcesSchedule.vue